import cloneDeep from 'lodash/cloneDeep'
import set from 'lodash/set'
import React, { useState } from 'react'

import { useJsonData } from './StructuredJson'
import StructuredJsonAccordion from './StructuredJsonAccordion'
import StructuredJsonTabs from './StructuredJsonTabs'
import { getDefaultJsonValue, getJsonPath, getJsonValue, normalizeToObject } from './jsonFieldHelpers'

export default function StructuredJsonBlock(props) {
  const { jsonPath, api, name, label, labelKey, schema, max, onUpdate } = props
  const { getJsonData } = useJsonData()
  const isNonArrayObject = !!schema?.isNonArrayObject

  const jsonData = getJsonData()

  let blocks
  if (isNonArrayObject) {
    blocks = [jsonData]
  } else if (jsonPath) {
    blocks = getJsonValue(jsonPath, jsonData)
  } else {
    blocks = jsonData
  }

  const isTabs = !!jsonPath
  const BlockComponent = isTabs ? StructuredJsonTabs : StructuredJsonAccordion

  const [selected, setSelected] = useState(jsonPath ? name + '0' : '')

  const handleSelection = (id) => {
    if (!isTabs && selected === id) setSelected('')
    else setSelected(id)
  }

  const handleDataChange = (newData) => {
    const currentJsonData = getJsonData()

    const effectiveNewData = normalizeToObject(newData, isNonArrayObject)

    if (JSON.stringify(currentJsonData) !== JSON.stringify(effectiveNewData)) {
      onUpdate && onUpdate(effectiveNewData)
    }
  }

  const handleAddItem = () => {
    if (isNonArrayObject) return

    const currentJsonData = getJsonData()
    const newData = cloneDeep(currentJsonData)
    const targetPath = getJsonPath(jsonPath, blocks.length, '', schema?.isNonArrayObject)
    const defaultValue = getDefaultJsonValue(schema)
    set(newData, targetPath, defaultValue)
    handleDataChange(newData)
  }

  const handleDeleteItem = (index) => {
    setSelected('')
    const currentJsonData = getJsonData()
    const newData = cloneDeep(currentJsonData)
    if (jsonPath) {
      const newValue = getJsonValue(jsonPath, newData)
      newValue.splice(index, 1)
      set(newData, jsonPath, newValue)
    } else {
      newData.splice(index, 1)
    }
    handleDataChange(newData)
  }

  const handleSort = (oldIndex, newIndex) => {
    setSelected('')
    const currentJsonData = getJsonData()
    const newData = cloneDeep(currentJsonData)
    const [removed] = newData.splice(oldIndex, 1)
    newData.splice(newIndex, 0, removed)
    handleDataChange(newData)
  }

  return (
    <BlockComponent
      selected={selected}
      api={api}
      name={name}
      label={label}
      blocks={blocks}
      max={max}
      labelKey={labelKey}
      schema={schema}
      jsonPath={jsonPath}
      isNonArrayObject={isNonArrayObject}
      onAddItem={handleAddItem}
      onDeleteItem={handleDeleteItem}
      onSelect={handleSelection}
      onSort={handleSort}
      onUpdate={onUpdate}
    />
  )
}
